import { render } from "./receiptList.vue?vue&type=template&id=623feffe&scoped=true"
import script from "./receiptList.vue?vue&type=script&lang=js"
export * from "./receiptList.vue?vue&type=script&lang=js"

import "./receiptList.vue?vue&type=style&index=0&id=623feffe&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623feffe"]])

export default __exports__